import i18n from '@dms/i18n';

import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

export const DimensionsHeightOptions = () => {
  const {catalogueApi} = useVehicleFormContext();
  return (
    <Field
      name="heightCategory"
      options={catalogueApi?.dimensionsHeightOptions ?? []}
      type="choice"
      label={i18n.t('entity.vehicle.labels.vehicleHeight')}
    />
  );
};
